// extracted by mini-css-extract-plugin
module.exports = {"content":"HomePage_content__2DT12"};